import { HttpResponseData } from '../interfaces/http-response-data.interface';
import {
    MeasurementToolsDetailsModel,
    ODataMeasurementToolsModel,
} from '../models/low-level/measurement-tools-details.model';
import measurementToolJson from './MeasToolSet.json';

export function getTestMeasurementTool(): MeasurementToolsDetailsModel[] {
    const measurementToolSet = (measurementToolJson as HttpResponseData<ODataMeasurementToolsModel[]>).d.results;

    return measurementToolSet.map((responseResult: ODataMeasurementToolsModel) =>
        MeasurementToolsDetailsModel.fromODataMeasurementTools(responseResult),
    );
}
